import { type FC } from 'react';

import { useStore } from '@nanostores/react';

import { $multiDecisionStore } from '@features/marketplace';
import { MakeSingleDecisionActions } from '@features/merchant';

import { HStack } from '@shared/ui-kit';

import { MerchantDecisionState } from '@api/services/merchants';

interface Props {
  merchantId: string;
  decision: MerchantDecisionState;
}

const SingleDecisionPanel: FC<Props> = ({ merchantId, decision }) => {
  const { isActive } = useStore($multiDecisionStore);

  return (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      opacity={isActive ? '0' : '1'}
      visibility={isActive ? 'hidden' : 'visible'}
      transition="all .15s ease-in-out"
    >
      <HStack />
      <MakeSingleDecisionActions
        merchantId={merchantId}
        decision={decision}
      />
    </HStack>
  );
};

export default SingleDecisionPanel;
